// @ts-nocheck
export default class Auth {
  constructor($log, $rootScope, $state, $http, Endpoints, Users, Orders, Business, localStorageService, Services, toastr, LoggedInUserStore) {
    'ngInject';

    Object.assign(this, {
      $log,
      $http,
      $state,
      $rootScope,
      Business,
      Endpoints,
      Users,
      Orders,
      Services,
      toastr,
      LoggedInUserStore,
      storage: localStorageService
    });
  }
  profile: any
  BODACDC_167 = FEATURE_BODACDC_167;

  getProfile() {
    return !this.isLoggedIn() && this.$http.get(this.Endpoints.users.me).then(({
      data
    }) => {
      // Business, Doctor and Super roles may access pims
      if (_.includes(data.roles, this.Users.ROLES.BUSINESS.NAME) || _.includes(data.roles, this.Users.ROLES.DOCTOR.NAME) || _.includes(data.roles, this.Users.ROLES.SUPER.NAME) || _.includes(data.roles, this.Users.ROLES.QA_USER.NAME) || _.includes(data.roles, this.Users.ROLES.SYSTEM.NAME)) {
        this.profile = data;
        // TODO: finding a better place to value the logged in user in the logged in user store when the auth process will be reworked
        this.LoggedInUserStore.setUserDetails(data);
        // _______________
        return this.profile;
      }

      if (this.BODACDC_167) {
        this.LoggedInUserStore.logout();
      } else {
        this.LoggedInUserStore.resetUserDetails();
        this.storage.remove('token');
      }
      throw new Error('Forbidden');
    });
  }

  authenticate(credentials) {
    return this.$http.post(this.Endpoints.users.authenticate, credentials).then(({
      data
    }) => {
      window.localStorage.setItem('token', data.token);

      return this.getProfile().then(() => {
        return this.Services.getCacheAreaCodes(true);
      });
    });
  }

  login(credentials) {
    // SPRINT 124
    // PIMS - Login process should not use the cached token at the first login attempt
    // https://app.asana.com/0/333364685358613/1124197631957152
    // if (this.getToken()) {
    //   return this.getProfile();
    // } else {
    //   return this.authenticate();
    // }
    return this.authenticate(credentials);
  }

  sendResetPasswordEmail(email) {
    return this.$http.post(this.Endpoints.users.resetPassword, {
      email,
      type: 'email'
    }, {
      loadingText: 'Sending Email'
    });
  }
  /*
    email, new password, code
  */


  resetPassword(form) {
    return this.$http.put(this.Endpoints.users.resetPassword, form, {
      loadingText: 'Resetting password'
    });
  }

  isLoggedIn() {
    return this.getToken() && this.profile;
  }

  getToken() {
    return this.storage.get('token') || window.localStorage.getItem('token');
  }

  logout(nextState = 'login') {
    this.LoggedInUserStore.resetUserDetails();
    if (this.Orders.current) {
      this.Orders.unlock().then(() => {
        this.$http.delete(this.Endpoints.users.authenticate).then(data => {}).catch(err => {
          this.toastr.error('Failed to remove token from Redis.');
        }).finally(() => {
          this._actuallyLogout(nextState);
        });
      }).catch(() => {
        this.toastr.error('Failed to unlock this visit. Please try again.');
      });
    } else {
      this.$http.delete(this.Endpoints.users.authenticate).then(data => {}).catch(err => {
        this.toastr.error('Failed to remove token from Redis.');
      }).finally(() => {
        this._actuallyLogout(nextState);
      });
    }
  }

  _actuallyLogout(nextState) {
    this.$rootScope.$broadcast('_actuallyLogout');
    this.profile = null;
    this.storage.remove('token');
    window.localStorage.removeItem('token');
    if (this.BODACDC_167) {
      this.LoggedInUserStore.logout();
    }
    this.$state.go(nextState);
  }

}

Auth.$inject = ["$log", "$rootScope", "$state", "$http", "Endpoints", "Users", "Orders", "Business", "localStorageService", "Services", "toastr", "LoggedInUserStore"];

